import React from "react";
import ButtonPicker from "./colorPicker.js";
import OrderSwitch from "./OrderSwitch.js";

function ColorPanel({
  colors = [],
  rows = [],
  onColorClick,
  onColorChange,
  activeTab,
  onTabChange,
  pickerAnchorRef,
  descending,
  rightToLeft,
  flatKnitting,
  knittingInTheRound,
  onOrderChange,
  onDirectionChange,
  onKnittingInTheRoundChange,
}) {
  const usedColorIndexes = [
    ...new Set(
      rows.flatMap((row) => row.pixels.map((pixel) => pixel.color))
    ),
  ];

  return (
    <div className="color-card">
      <div className="tabs">
        <button
          type="button"
          className={activeTab === 0 ? "tab active" : "tab"}
          onClick={() => onTabChange(0)}
        >
          PLAY WITH COLOR
        </button>

        <button
          type="button"
          className={activeTab === 1 ? "tab active" : "tab"}
          onClick={() => onTabChange(1)}
        >
          KNITTING ORDER
        </button>
      </div>
      <div className="tab-content">
      {activeTab === 0 && (
        <div className="tab-panel">
          {usedColorIndexes.map((colorIndex) => (
            <div
              key={`color-${colorIndex}`}
              className="color-swatch-wrapper"
              onClick={() => onColorClick?.(colors[colorIndex], colorIndex)}
            >
              <ButtonPicker
                color={colors[colorIndex]}
                ind={colorIndex}
                anchorRef={pickerAnchorRef}
                onColorChange={(newColor, ind) =>
                  onColorChange?.(ind, newColor)
                }
              />
            </div>
          ))}
        </div>
      )}

      {activeTab === 1 && (
       
       <div className="tab-panel">
          <OrderSwitch
            descending={descending}
            rightToLeft={rightToLeft}
            flatKnitting={flatKnitting}
            knittingInTheRound={knittingInTheRound}
            onChange={onOrderChange}
            onDirectionChange={onDirectionChange}
            onKnittingInTheRoundChange={onKnittingInTheRoundChange}
          />
        </div>
       
      )}
    </div>
    </div>
  );
}

export default ColorPanel;